import React from "react";

const Introduction = ({ data }) => {
  return (
    <div className="wow zoomIn">
      <p dangerouslySetInnerHTML={{ __html: data }}></p>
    </div>
  );
};

export default Introduction;
